module.exports = __webpack_public_path__ + "static/media/arrow-asc.e8690a78.svg";